<template>
  <v-container class="dashboard">
    <v-row>
      <v-col sm="6" cols="12" md="6" lg="3">
        <router-link tag="a" to="/participant-management">
          <material-stats-card
            color="#156a59"
            icon="mdi-briefcase-search-outline"
            title="Participant management"
            value
          />
        </router-link>
      </v-col>
      <v-col sm="6" cols="12" md="6" lg="3">
        <router-link tag="a" to="/roster">
          <material-stats-card
            color="#156a59"
            icon="mdi-timetable"
            title="Roster"
            value
            sub-icon="mdi-tag"
            sub-text
          />
        </router-link>
      </v-col>
      <v-col sm="6" cols="12" md="6" lg="3" v-if="isAdmin">
        <router-link tag="a" to="/invoicing-billing">
          <material-stats-card
            color="#156a59"
            icon="mdi-currency-usd"
            title="Invoicing and billing"
            value
            sub-icon="mdi-tag"
            sub-text
          />
        </router-link>
      </v-col>
      <v-col sm="6" cols="12" md="6" lg="3">
        <router-link tag="a" to="/feedback">
          <material-stats-card
            color="#156a59"
            icon="mdi-clipboard-outline"
            title="Feedback"
            value
            sub-icon="mdi-tag"
            sub-text
          />
        </router-link>
      </v-col>
      <v-col sm="6" cols="12" md="6" lg="3" v-if="isAdmin">
        <router-link tag="a" to="/admin">
          <material-stats-card
            color="#156a59"
            icon="mdi-account-supervisor-circle"
            title="Admin Dashboard"
            value
          />
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" cols="12" md="12" lg="12">
        <v-card>
          <v-card-text>
            <div style="height: 100%">
              <canvas id="myChart" style="height: 60vh"></canvas>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="container">
      <Button @click="previous()" v-if="perPage !== 0" class="button prev"
        >Previous</Button
      >
      <Button
        @click="next()"
        v-if="perPage !== Math.round(reportData.length / 10) * 10"
        class="button next"
        >Next</Button
      >
    </div>
  </v-container>
</template>

<script>
// function generateHash(data) {
//   return btoa(JSON.stringify(data));
// }

var Chart = require("chart.js");
import * as caseService from "../services/caseService";
import * as budgetItemService from "../services/budgetItemService";
//import * as reportService1 from "../services/reportService1";
let cachedReportData = null;
export default {
  data() {
    return {
      slider: 0,
      perPage: 0,
      reportData: [],
      limitReportData: [],
      cases: [],
      budgetItems: [],
     // isAdmin: false,
      tabs: 0,
      myChart: "",
      list: {
        0: false,
        1: false,
        2: false,
      },
    };
  },

   mounted() {
    if (cachedReportData) {
      this.reportData = cachedReportData;
      this.limitReportData = this.reportData.slice(0, 10);
      this.showChart(this.limitReportData);
    } else {
      //await this.init();
      cachedReportData = this.reportData;
    }
  },
  computed: {
  currentOrganisation() {
    return this.$store.getters.currentOrganisation;
  },
  user() {
    return this.$store.getters.user;
  },
  isAdmin() {
    if (!this.user || !this.user.roles) return false;
    return (
      this.user.roles.includes("System Administrator") ||
      this.user.roles.includes("Organisation Administrator")
    );
  }
},
watch: {
  user: {
    immediate: true,
    handler(newUser) {
      if (newUser && this.currentOrganisation) {
        this.init();
      } else {
        this.cases = [];
      }
    }
  },
  currentOrganisation: {
    immediate: true,
    handler(newOrg) {
      if (newOrg && this.user) {
        this.init();
      }
    }
  }
},
  methods: {
    async init() {
      if (!this.currentOrganisation || !this.user) {
      this.cases = [];
      return;
    }

      const result = await caseService.activeCases(this.currentOrganisation.id, this.user);
      const cases = result.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      this.cases = cases;
      const reportData = [];

      await Promise.all(
        this.cases.map(async (c) => {
          const result = await budgetItemService.list(
            this.currentOrganisation.id,
            c.id
          );
          const budgetItems = result.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          budgetItems.forEach((item) => {
            if (!reportData.find((r) => r.budgetItemId === item.id)) {
              reportData.push({
                budget: item.budget,
                budgetItem: item.title,
                budgetItemId: item.id,
                budgetItemLongName: `${c.participantDetails.firstname} ${c.participantDetails.lastname} - ${item.title}`,
                firstname: c.participantDetails.firstname,
                lastname: c.participantDetails.lastname,
                organisation: this.currentOrganisation.name,
                participantId: c.id,
                totalSpent:
                  item.spent !== undefined && item.spent !== null
                    ? item.spent
                    : 0,
              });
            }
          });
        })
      );

      this.reportData = reportData.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.budgetItemId === item.budgetItemId)
      );
      this.reportData.sort((a, b) => a.lastname.localeCompare(b.lastname));
      this.limitReportData = this.reportData.slice(0, 10);
      //this.limitReportData.sort((a, b) => a.lastname.localeCompare(b.lastname));

      this.$nextTick(() => {
        this.showChart(this.limitReportData);
      });
    },
    async fetchBudgetItemsSummary() {
  const result = await caseService.activeCases(this.currentOrganisation.id);
  const cases = result.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  let summary = [];

  await Promise.all(
    cases.map(async (c) => {
      const result = await budgetItemService.list(this.currentOrganisation.id, c.id);
      const budgetItems = result.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      budgetItems.forEach((item) => {
        summary.push({
          budgetItemId: item.id,
          budget: item.budget,
          spent: item.spent,
        });
      });
    })
  );

  return summary;
},

    previous() {
      if (this.myChart) this.myChart.destroy();
      if (this.slider === 0) {
        this.perPage -= 10;
        for (let i = 0; i < 10; i++) {
          let j = i + this.perPage;
          if (j < this.reportData.length)
            this.limitReportData[i] = this.reportData[j];
        }
        // this.limitReportData.sort((a, b) => a.lastname.localeCompare(b.lastname));
        this.showChart(this.limitReportData);
      }
    },

    next() {
      if (this.myChart) this.myChart.destroy();
      this.slider = 1;
      if (this.slider === 1) {
        this.perPage += 10;
        if (this.perPage < Math.round(this.reportData.length / 10) * 10) {
          for (let i = 0; i < 10; i++) {
            let j = i + this.perPage;
            if (j < this.reportData.length) {
              this.limitReportData[i] = this.reportData[j];
            }
          }
        } else {
          let k =
            this.reportData.length -
            Math.round(this.reportData.length / 10) * 10;
          for (let i = 0; i < k; i++) {
            this.limitReportData[i] = this.reportData[i + this.perPage];
          }
        }
        //this.limitReportData.sort((a, b) => a.lastname.localeCompare(b.lastname));
        this.showChart(this.limitReportData);
        this.slider = 0;
      }
    },

    showChart(chartData) {
      const ctx = document.getElementById("myChart").getContext("2d");
      Chart.defaults.global.defaultFontSize = 13;
      this.myChart = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: chartData.map((x) => x.budgetItemLongName),
          datasets: [
            {
              label: "Budget",
              data: chartData.map((x) => x.budget),
              backgroundColor: "rgba(25, 128, 107, 0.8)",
              borderColor: "rgba(25, 128, 107, 1)",
              borderWidth: 1,
            },
            {
              label: "Spent",
              data: chartData.map((x) => x.totalSpent),
              backgroundColor: "rgba(211, 211, 211, 0.8 )",
              borderColor: "rgba(211, 211, 211,1)",
              borderWidth: 1,
            },
          ],
        },
     
        options: {
          indexAxis: "y",
          maintainAspectRatio: false,
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                autoSkip: true,
                maxTicksLimit: 10,
                callback: (value) => "$" + value,
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                maxTicksLimit: 10,
              },
            },
          },
        },
      });
      this.myChart.canvas.parentNode.style.height = "100%";
    },
  },
};
</script>

<style>
.dashboard .col {
  padding: 6px;
}
.button {
  background-color: #156a59;
  border-radius: 5px;
  border: 1px solid #cccccc;
  color: white;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.button:hover {
  background-color: #d3d3d3;
  color: black;
}
.next {
  float: right !important;
}
</style>
